import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './style/Payment.css';
import { API_CONFIG } from '../../config';
import useUsersData from '../Auth/AllUsers';
import UsePaymentItems from "../AdminPanel/UsePaymentItems";
import TopNavbar from '../home/TopNavbar';
import { UserPen } from 'lucide-react';
import OfferCountdown from './OfferCountdown';
import SubcriptionOfferTime from '../AdminPanel/SubcriptionOfferTime';


const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.PAYRAZORPAY}`;

function MakePayment() {
    // const userId = localStorage.getItem('userPhone') || "";
    const { userId } = useParams();
    const { subcriptionOffer, subcriptionOfferLoading } = SubcriptionOfferTime()
    const { paymentItems, loading } = UsePaymentItems();
    const { users } = useUsersData();

    const [selectedItem, setSelectedItem] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const navigate = useNavigate();

    const allOfferTime = subcriptionOffer.find(offer => offer.id === 1);
    const offerTime = allOfferTime?.time;
    const offerPrice = allOfferTime?.offerPrice;

    //const expiryTime = "2026-09-28T23:59:59";
    const expiryTime = offerTime;

    // Find current user details from context/hook
    const matchUser = users?.find(user => String(user.phone) === String(userId));
    const userName = matchUser?.name || "No";
    const userEmail = matchUser?.email || "sarwar123@gmail.com";

    const [copied, setCopied] = useState(false);
    const payUrl = `${window.location.origin}/make-payment/${userId}`;



    const handleShare = async () => {
        if (navigator.share) {
            await navigator.share({ title: 'Payment Link', url: payUrl });
        } else {
            navigator.clipboard.writeText(payUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };



    // Save payment details to backend after Razorpay success
    const savePaymentDetails = async (paymentId, itemToBuy) => {
        try {
            const payload = {
                name: userName,
                phone: String(userId),
                email: userEmail,
                amount: itemToBuy?.price || "100",
                buyed: itemToBuy?.type || "all",
                year: String(itemToBuy?.id || "1"),
                paymentId: paymentId,
                coupon: "No",
                date: new Date().toISOString()
            };

            console.log('🔵 Sending Payment Data to API:', CREATE_USER_ENDPOINT);
            console.log('🔵 Payload:', payload);

            const response = await fetch(CREATE_USER_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
                mode: 'cors'
            });

            const responseText = await response.text();
            console.log('🔵 Raw Backend Response:', responseText);

            let data;
            try {
                data = JSON.parse(responseText);
            } catch (parseError) {
                console.error('🔴 Server did not return JSON. Raw output logged above.');
                throw new Error('Server returned non-JSON response.');
            }

            if (!response.ok) {
                throw new Error(data.message || `API failed with HTTP status ${response.status}`);
            }

            console.log('🟢 API Success Response:', data);
            return data;
        } catch (error) {
            console.error('🔴 savePaymentDetails Error:', error.message);
            throw error;
        }
    };

    // Trigger Razorpay Checkout Modal
    const handlePayment = async () => {
        if (!userId) {
            alert('Phone number / User ID is required.');
            return;
        }

        if (!selectedItem) {
            alert('Please select an item first.');
            return;
        }

        setIsProcessing(true);
        const currentAmount = Number(selectedItem.price || 100);


        const options = {
            key: "rzp_live_RbA9HRGkYYL6G0",
            // key: "rzp_test_TVos9I40EBgmwk",
            amount: currentAmount * 100, // Amount in paise
            currency: "INR",
            name: selectedItem.name || "Razorpay",
            description: selectedItem.about || "Subscription payment",
            handler: async function (response) {
                console.log('🟡 Razorpay Gateway Response:', response);

                try {
                    await savePaymentDetails(response.razorpay_payment_id, selectedItem);
                    console.log('🟢 Details saved successfully');
                    localStorage.setItem('userPayment', userId);
                    navigate("/payment-success");
                } catch (error) {
                    console.error('🔴 Payment saved failed due to API error:', error);
                    alert(`Payment successful on Razorpay, but failed to save in Database:\n\n${error.message}`);
                    navigate(`/success?payment_id=${response.razorpay_payment_id}`);
                } finally {
                    setIsProcessing(false);
                }
            },
            prefill: {
                name: userName !== "No" ? userName : "User",
                email: userEmail,
                contact: userId
            },
            notes: {
                address: "My address",
            },
            theme: {
                color: "#000"
            }
        };

        try {
            const pay = new window.Razorpay(options);

            pay.on('payment.failed', function (response) {
                console.error('🔴 Payment failed:', response.error);
                setIsProcessing(false);
                alert(`Payment failed: ${response.error.description}`);
            });

            pay.open();
        } catch (error) {
            console.error('🔴 Error opening payment modal:', error);
            setIsProcessing(false);
            alert('Error initializing payment. Please try again.');
        }
    };






    return (
        <div className="product-container">
            <TopNavbar name="Select the item" />
            <br></br><br></br><br></br><br></br>

            <div className="product-grid">



                <div className="product-card" style={{ background: "#80fbff", padding: "16px", borderRadius: "10px" }}>
                    <div className="card-header">


                        <p>Hi {userName}, you're almost there! Complete your payment to unlock all premium content and get the most out of NEET Prep.</p>

                        <br></br>
                        <p style={{ color: "green" }}>Don't have a UPI app? You can also share this payment link with someone you trust to complete the payment for you.</p>
                        <button onClick={handleShare} className="email-button" style={{ width: "100%", padding: "8px", cursor: "pointer" }}>
                            {copied ? "Link Copied! 📋" : "🔗 Share Payment Link"}
                        </button>
                    </div>
                </div>


                {(!paymentItems || paymentItems.length === 0) ? (<></>) : (<>
                    {/* Payment Item Selection List */}
                    {paymentItems.slice().reverse().map((item) => {
                        const itemId = item.id;
                        const isSelected = selectedItem?.id === itemId;

                        return (
                            <div
                                key={itemId}
                                className={`product-card ${isSelected ? 'selected' : ''}`}
                                onClick={() => setSelectedItem(item)}
                            >
                                <div className="card-header same-line-item">
                                    <h4>{item.name || "Premium Plan"}  </h4>
                                    <p style={{ fontSize: '15px', float: 'right', color: 'red' }}> <OfferCountdown targetDate={expiryTime} /> </p>
                                </div> <br></br>

                                <div className="card-body-row">
                                    <p className="same-line-item">
                                    <del style={{ color: "red", fontSize: "16px" }}>
                                        <p style={{ color: "orange" }}>₹{item.price * offerPrice}</p>
                                    </del>

                                    <span style={{ fontSize: "18px", color: "green", marginLeft: "8px" }}>
                                        ₹{item.price}
                                    </span>
                                </p>
                                <p style={{ color: "orange" }}>Limited-Time Offer</p>
                                 
                                <div className="radio-wrapper">

                                    <input
                                        type="radio"
                                        name="product-selection"
                                        checked={isSelected}
                                        onChange={() => setSelectedItem(item)}
                                        style={{
                                            width: "30px",
                                            height: "30px",
                                            cursor: "pointer"
                                        }}
                                    />
                                    <p style={{ fontSize: "13px" }} className="highlight-text">Select</p>
                                </div>

                            </div>



                            <div className="same-line-item">
                                <p style={{ paddingBottom: "10px", fontSize: "15px" }}>Only ₹{item.price}</p>
                                <p style={{ fontSize: "12px" }}>{item.about}</p>

                            </div>


                            <div className="card-footer">
                                <p className="offer-box" style={{ fontSize: "14px", paddingBottom: "17px", marginBottom: "10px" }}> Purchase now before the price returns to the original price of ₹{item.price * offerPrice}.

                                    <p style={{ fontSize: '12px', float: 'right', color: 'red' }}> <OfferCountdown targetDate={expiryTime} /> </p>

                                </p>

                                <hr></hr>
                                <p style={{ fontSize: "12px", color: "green" }}> <strong >Access all of: </strong>📋Mock Tests, 📅PYQs, ☀️DPP,  👑Formulas, 🎴Flashcards, 🧠Mind Maps, 📕Topper Notes & more.</p>
                                <hr></hr>
                                <span className="validity">Validity: {item.valid}</span>

                            </div>
                            </div>
                        );
                    })}
                </>)}


            </div>

            {/* Bottom Checkout Section */}
            <div className="payment-checkout-button">
                {userId ? (
                    <>
                        {selectedItem ? (
                            <div className="checkout-section">
                                <button
                                    onClick={handlePayment}
                                    disabled={isProcessing}
                                    className="link checkout-btn"
                                    style={{ width: '100%', cursor: isProcessing ? 'not-allowed' : 'pointer', border: 'none' }}
                                >
                                    <p>
                                        {isProcessing
                                            ? 'Opening Razorpay...'
                                            : <>{selectedItem.name} <strong style={{ color: "orange" }}> ₹{selectedItem.price}</strong> ➔</>}
                                    </p>
                                </button>
                            </div>
                        ) : (
                            <div className="link checkout-btn">
                                <p className="highlight-text">Please select an item.</p>
                            </div>
                        )}
                    </>
                ) : (
                    <Link to="/signup" className="link checkout-btn">
                        <p className="highlight-text">Create account before payment.</p>
                    </Link>
                )}
            </div>
        </div>
    );
}

export default MakePayment;